import PropTypes from 'prop-types';
import React from 'react';

import TableCell from './TableCell';

export default function TableRow(props) {
  if (!props.cell || !props.cell.length) {
    return false;
  }

  const classes = [];
  if (props.header) {
    classes.push('header');
  }
  if ('DASHED' === props.format) {
    classes.push('dashed');
  }

  const cells = props.cell.map((cell, index) => <TableCell key={index} {...cell}/>);

  return <tr className={classes.join(' ')}>{cells}</tr>;
}

TableRow.propTypes = {
  header: PropTypes.bool,
  format: PropTypes.oneOf(['SOLID', 'DASHED']),
  cell: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Common/components/TableRow.js